import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { HttpErrorHandler } from '@spartacus/core';
import { effects } from './effects';
import { CustomBadRequestHandler } from './handlers/custom-bad-request-handler';
import { CartStockStatusInterceptor } from './http-interceptors';

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    { provide: HTTP_INTERCEPTORS, useExisting: CartStockStatusInterceptor, multi: true },
    {
      provide: HttpErrorHandler,
      useExisting: CustomBadRequestHandler,
      multi: true,
    },
  ],
})
export class CustomGlobalMessageModule {}
